// extracted by mini-css-extract-plugin
export default {"base":"styles-module--base--lNLJU","item":"styles-module--item--AQpew"};